// ENTERPRISE-managed loan-scheme config CRUD — POST/PUT are ENTERPRISE-only
// server-side (lendcord-core's LoanSchemeService.requireEnterpriseCaller,
// LEND-116). No DELETE — isActive (part of LoanSchemeRequest) is the
// soft-disable mechanism, see docs/flows/loan-scheme-config.md.

import { baseApi } from "@/app/store/baseApi";
import type { LoanScheme, LoanSchemeRequest } from "../setup.types";

export const loanSchemesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listLoanSchemes: builder.query<LoanScheme[], void>({
      query: () => ({ url: "/enterprise/loan-schemes", auth: true }),
      providesTags: (schemes) =>
        schemes
          ? [{ type: "LoanScheme" as const, id: "LIST" }, ...schemes.map((s) => ({ type: "LoanScheme" as const, id: s.id }))]
          : [{ type: "LoanScheme" as const, id: "LIST" }],
    }),
    createLoanScheme: builder.mutation<LoanScheme, LoanSchemeRequest>({
      query: (body) => ({ url: "/enterprise/loan-schemes", method: "POST", body, auth: true }),
      invalidatesTags: [{ type: "LoanScheme", id: "LIST" }],
    }),
    updateLoanScheme: builder.mutation<LoanScheme, { id: string; body: LoanSchemeRequest }>({
      query: ({ id, body }) => ({ url: `/enterprise/loan-schemes/${id}`, method: "PUT", body, auth: true }),
      invalidatesTags: (result, error, { id }) => [
        { type: "LoanScheme", id: "LIST" },
        { type: "LoanScheme", id },
      ],
    }),
  }),
});

export const { useListLoanSchemesQuery, useCreateLoanSchemeMutation, useUpdateLoanSchemeMutation } = loanSchemesApi;
